var _path, _rect, _rect2, _rect3, _rect4, _rect5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ABD5"
    },
    d: "M171.678,442.714h-48.184V117.47c26.501,0,26.501,24.092,53.003,24.092 c26.381,0,26.381-24.092,52.882-24.092s26.501,24.092,53.003,24.092s26.501-24.092,53.124-24.092 c26.501,0,26.501,24.092,53.003,24.092v301.151h-48.184v60.23H171.678V442.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7ECED"
    },
    d: "M123.494,117.47V9.056h265.013v132.507c-26.501,0-26.501-24.092-53.003-24.092 c-26.622,0-26.622,24.092-53.124,24.092s-26.501-24.092-53.003-24.092c-26.501,0-26.501,24.092-52.882,24.092 C149.995,141.563,149.995,117.47,123.494,117.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A0D4"
    },
    d: "M133.637,119.035c-2.95-0.913-6.188-1.564-10.143-1.564v325.243h48.184v60.23h168.644v-60.23h48.184 v-65.858C268.885,334.63,174.544,239.274,133.637,119.035z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.562,322.257V0H207.816v18.112H379.45v112.831c-4.26-1.682-7.47-4.597-11.353-8.128 c-7.058-6.417-15.841-14.402-32.594-14.402c-16.822,0-25.633,7.992-32.713,14.415c-6.193,5.617-10.669,9.677-20.409,9.677 c-9.749,0-14.221-4.064-20.41-9.691c-7.058-6.415-15.841-14.401-32.593-14.401c-16.773,0-25.553,8-32.608,14.428 c-6.157,5.61-10.605,9.664-20.274,9.664c-9.749,0-14.221-4.064-20.409-9.69c-5.66-5.145-12.44-11.289-23.536-13.525V18.112h51.172V0 h-69.285v451.77h48.184V512h186.757v-60.23h48.184V346.344H379.45v87.314h-48.184v60.23H180.734V451.77h111.405v-18.112H132.55 V128.09c4.26,1.682,7.47,4.597,11.353,8.128c7.058,6.417,15.841,14.402,32.593,14.402c16.683,0,25.437-7.977,32.473-14.387 c6.184-5.634,10.651-9.705,20.409-9.705c9.749,0,14.221,4.064,20.409,9.69c7.058,6.417,15.841,14.402,32.594,14.402 c16.731,0,25.518-7.971,32.578-14.374c6.22-5.641,10.714-9.718,20.544-9.718c9.749,0,14.221,4.064,20.41,9.691 c5.66,5.145,12.44,11.289,23.536,13.525v172.513H397.562z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 153.605,
    y: 66.253,
    width: 30.115,
    height: 18.112
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 183.72,
    y: 42.161,
    width: 30.115,
    height: 18.112
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 189.745,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.112,
    height: 168.638
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.6,
    y: 376.46,
    style: {
      fill: "#FFFFFF"
    },
    width: 18.112,
    height: 24.092
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.911,
    y: 319.225,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.092,
    height: 18.112
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 256.001,
    y: 289.11,
    width: 24.092,
    height: 18.112
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.205,
    y: 216.83,
    style: {
      fill: "#FFFFFF"
    },
    width: 24.092,
    height: 18.112
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 310.205,
    y: 361.379,
    width: 24.092,
    height: 18.112
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 225.886,
    y: 216.83,
    width: 24.092,
    height: 18.112
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2);
export default __webpack_public_path__ + "static/media/h2.ae21de3a9c746f07b6bf02192e9de220.svg";
export { ForwardRef as ReactComponent };